import { Box, Typography } from '@mui/material';
import { MprcNotice } from 'components/MprcNotice';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PreviewNotice: React.FC = () => {
    const { t } = useTranslation("lms");

    return <Box sx={(theme) => ({ maxWidth: theme.breakpoints.values["xl"], margin: "0 auto" })}>
        <MprcNotice elevation="medium" items={[{
            text:
                <>
                    <Typography variant="overline" color="warning.main" component="p"><strong>{t("Monitoring.TrainingPreview.PreviewTitle")}</strong></Typography>
                    <Typography variant="h6" color="black" component="p">{t("Monitoring.TrainingPreview.PreviewMessage")}</Typography>
                </>
        }]}
        />
    </Box>;
};

export default PreviewNotice;
